import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import {convertPipeToBrTag} from "../../utils";
import AccordionItem from "../accordion-item";
import './styles.css';

/**
 *  AccordionContainer
 */
class AccordionContainer extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    pcText: PropTypes.string,
    mbText: PropTypes.string,
    items: PropTypes.array,
    color: PropTypes.string
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    pcText: null,
    mbText: null,
    items: null,
    color: null
  };
  
  constructor(props) {
    super();
    this.props = props;
  }
  
  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      pcText,
      mbText,
      items,
      color
    } = this.props;

    let containerPcText, containerMbText;
    containerPcText = pcText != null && pcText !== '' ? pcText : '';
    containerMbText = mbText != null && mbText !== '' ? mbText : (pcText != null && pcText !== '' ? pcText : '');
        
    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <div className='AccordionContainer'>
          <div className={'AccordionContainer__container AccordionContainer__container--' + color}>
            <div className={"AccordionContainer__container__title"}>
              {(containerPcText && containerPcText !== '') ? <span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(containerPcText)}}
                                                                   className="AccordionContainer__container__title__text--pc"/>: null}
              {(containerMbText && containerMbText !== '') ? <span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(containerMbText)}}
                                                                   className="AccordionContainer__container__title__text--mb"/>: null}
            </div>
            <ul className={"AccordionContainer__container__list"}>
              {items.map((item, index) => {
                let itemPcText, itemMbText;
                itemPcText = item.props.pcText;
                itemMbText = item.props.mbText;
                return (
                  <li
                    key={index}
                    ref={'item' + index}
                    className={"AccordionContainer__container__list__item"}
                  >
                    <div className={"AccordionContainer__container__list__item__content"}>
                      <AccordionItem 
                        {...item.props}
                        color={color}
                      ></AccordionItem>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </Wrapper>
    )
  }
  
}

export default AccordionContainer;



// WEBPACK FOOTER //
// ./src/containers/accordion-container/index.jsx